import { DepositionFactory } from 'src/dataFactory';
import { rawDataToDepositionListItem } from 'src/dataFactory/depositionFactory';

export function handleGetDepositionsSuccess(action, response) {
  const convertedData = rawDataToDepositionListItem(response.depositions);
  action.onSuccess(convertedData, response.total);
}

export function handleGetDepositionSuccess(action, response) {
  const deposition = !!response ? DepositionFactory.depositionResponseToDeposition(response) : {};

  if (deposition && action.onSuccess) {
    action.onSuccess(deposition);
    return;
  }
  action.onError && action.onError({});
}

export function handleGetExhibitSuccess(action, response) {
  const exihibitUploaders = !!response ? DepositionFactory.exhibitFileResponseToDataFiles(response) : [];

  if (exihibitUploaders) {
    if (action.onSuccess) {
      action.onSuccess(exihibitUploaders);
    }
    return;
  }
  action.onError && action.onError({});
}

export function handleGetFinalSuccess(action, response) {
  const fileUploaders = !!response ? DepositionFactory.finalFileResponseToDataFiles(response) : [];
  const total = response.total ?? undefined;

  if (fileUploaders) {
    if (action.onSuccess) {
      action.onSuccess(fileUploaders, total);
    }
    return;
  }
  action.onError && action.onError({});
}

export function handleGetRequesterSuccess(action, response) {
  const requester = !!response ? DepositionFactory.patiesResponseToPeople(response) : {};

  if (requester) {
    if (action.onSuccess) {
      action.onSuccess(requester);
    }
    return;
  }
  action.onError && action.onError({});
}

export function handleGetInvoledPartiesSuccess(action, response) {
  const involvedPaties = !!response ? DepositionFactory.involvedPatiesResponseToPeople(response.involvedParties) : [];

  if (involvedPaties) {
    if (action.onSuccess) {
      action.onSuccess(involvedPaties);
    }
    return;
  }
  action.onError && action.onError({});
}

export async function handleGetProductionSuccess(action, response) {
  const fileUploaders = !!response ? DepositionFactory.productionFileResponseToDataFiles(response) : {};

  if (fileUploaders) {
    if (action.onSuccess) {
      action.onSuccess(fileUploaders);
    }
    return;
  }
  action.onError && action.onError({});
}
